import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
import { useCurrency } from '../contexts/CurrencyContext';
import { useMetaPixel } from '../hooks/useMetaPixel';
export function PricingSection() {
  const ref = useRef(null);
  const {
    formatPrice
  } = useCurrency();
  const {
    trackAddToCart
  } = useMetaPixel();
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 px-4 md:px-6" data-id="element-193">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={isInView ? {
      opacity: 1,
      scale: 1
    } : {
      opacity: 0,
      scale: 0.95
    }} transition={{
      duration: 0.6
    }} className="max-w-md mx-auto bg-white rounded-3xl shadow-2xl overflow-hidden border border-stone-100" data-id="element-194">
        <div className="bg-charcoal p-6 text-center" data-id="element-195">
          <h3 className="text-cream font-serif text-2xl font-bold" data-id="element-196">
            Instant Access
          </h3>
        </div>

        <div className="p-8 md:p-12 text-center" data-id="element-197">
          <div className="inline-block bg-coral/10 text-coral font-bold text-sm px-3 py-1 rounded-full mb-4" data-id="element-198">
            🎉 60% OFF — Limited Time
          </div>
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-199">
            <span className="text-2xl text-warm-gray line-through" data-id="element-200">
              {formatPrice(15.99)}
            </span>
            <span className="text-5xl font-bold text-coral" data-id="element-201">
              {formatPrice(6.39)}
            </span>
          </div>
          <p className="text-warm-gray mb-8" data-id="element-202">
            One-time payment. Yours forever.
          </p>

          <a href="https://www.gemmamama.com/cart/45506271477899:1" target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="w-full bg-coral hover:bg-coral-hover text-white text-xl font-bold py-4 rounded-xl shadow-lg shadow-coral/30 transition-all transform hover:-translate-y-1 mb-6 inline-block text-center" data-id="element-203">
            Download Now — {formatPrice(6.39)}
          </a>

          <div className="flex items-start gap-3 text-left bg-stone-50 p-4 rounded-lg" data-id="element-204">
            <ShieldCheck className="w-6 h-6 text-teal shrink-0 mt-0.5" data-id="element-205" />
            <p className="text-sm text-warm-gray" data-id="element-206">
              <span className="font-bold text-charcoal" data-id="element-207">Simple Guarantee:</span>{' '}
              If it doesn't feel like something you'd be proud to gift, you
              shouldn't keep it. Full refund, no questions asked.
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}